let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("uEo6e")).then(() => parcelRequire('9bR8s'));